module.exports = __webpack_public_path__ + "img/appletsImg.4a8c966e.png";